import React from 'react';

export default function Page403() {
  return (
    <h1>Ops, você não tem permissão para acessar este recurso.</h1>
  )
}